<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path stroke="#000" d="M18 13c0 3.16-3 5.66-6 5.66S6 16.16 6 13m6 6v2m-3 0h6m-3-5a4 4 0 01-4-4V6a4 4 0 118 0v6a4 4 0 01-4 4z"/>
</svg>
